import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiService } from '../../services/api/api.service';

export const loginUser = createAsyncThunk('SESSION/LOGIN',
  async ({username, password}, thunkApi) => {
    try {
      const response = await ApiService.post('/login', {username, password});
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

export const getSession = createAsyncThunk('SESSION/GET',
  async ({}, thunkApi) => {
    try {
      const response = await ApiService.get('/user');
      let data = await response.data;
      if (response.status === 200) {
        return data;
      }
      return thunkApi.rejectWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e);
    }
  });

const initialState = {
  data: undefined,
  isFetching: false,
  isSuccess: false,
  isError: false,
  errorMessage: '',
};

export const sessionSlice = createSlice({
  name: 'SESSION',
  initialState: initialState,
  reducers: {
    logout: (state) => {
      return initialState;
    },
    updateVendor: (state, { payload }) => {
      state.data.teams[0].vendor = payload;
      return state;
    }
  },
  extraReducers: {
    [loginUser.fulfilled]: (state, { payload }) => {
      state.data = payload;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [loginUser.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [loginUser.pending]: (state) => {
      state.isFetching = true;
    },

    [getSession.fulfilled]: (state, { payload }) => {
      state.data = payload;
      state.isFetching = false;
      state.isSuccess = true;
      return state;
    },
    [getSession.rejected]: (state, { payload }) => {
      state.isFetching = false;
      state.isError = true;
      state.errorMessage = payload?.message || '';
    },
    [getSession.pending]: (state) => {
      state.isFetching = true;
    },
  }
});

export const { logout, updateVendor } = sessionSlice.actions;

// for now we are mocking [0] since we are assuming one account will have one vendor :pray:

export const getTeamVendorId = (state) => state?.data?.teams?.[0]?.vendor?.id;

export const getVendor = (state) => state?.data?.teams?.[0]?.vendor;
